import { IUser } from 'redux/store/user/types'
import { ProfileAbilityBuilder } from '../types'
import { ACTIONS, ROLES, SUBJECTS } from 'features/Permission/constants'
import { isInsideCommunityCondition } from '../conditions'

export const defineCommunityProfileAbilities = (
  builder: ProfileAbilityBuilder,
  role: string,
  user: IUser,
  profileId?: string
) => {
  const { can } = builder

  if (
    user.uuid === profileId &&
    (user.role === ROLES.HOSPITAL_USER || user.role === ROLES.HOSPITAL_ADMIN)
  ) {
    can(ACTIONS.EDIT, SUBJECTS.HIDE_PHONE_NUMBER)
  }

  if (user.uuid !== profileId) {
    if (
      user.role === ROLES.COMMUNITY_PRESIDENT &&
      role === ROLES.COMMUNITY_PRESIDENT
    ) {
      can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
    }

    if (
      user.role === ROLES.VICE_PRESIDENT &&
      (role === ROLES.COMMUNITY_PRESIDENT || role === ROLES.VICE_PRESIDENT)
    ) {
      can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
    }

    if (
      user.role === ROLES.CONTRACT_STEWARD &&
      (role === ROLES.COMMUNITY_PRESIDENT ||
        role === ROLES.VICE_PRESIDENT ||
        role === ROLES.CLINICAL_COORDINATOR ||
        role === ROLES.CONTRACT_STEWARD)
    ) {
      can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
    }

    // Hospital admin can edit stakeholder profiles -- new functionality
    if (user.role === ROLES.HOSPITAL_ADMIN) {
      can(ACTIONS.DISABLED, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
      can(ACTIONS.DISABLED, SUBJECTS.FORM_HOSPITAL_INPUT)
      if (role === ROLES.HOSPITAL_USER) {
        can(ACTIONS.EDIT, SUBJECTS.FORM_HOSPITAL_LIST)
      } else {
        can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
      }
    }
  }

  if (
    user.uuid !== profileId &&
    (user.role === ROLES.HOSPITAL_USER ||
      user.role === ROLES.ANALYST ||
      user.role === ROLES.LEGAL ||
      user.role === ROLES.FINANCE ||
      user.role === ROLES.COMMUNITY_RCA)
  ) {
    can(ACTIONS.EDIT, SUBJECTS.FORM_ITEM)
  }

  if (role === ROLES.VICE_PRESIDENT) {
    // can(ACTIONS.VIEW, SUBJECTS.FORM_COMMUNITY_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
    can(ACTIONS.EDIT, SUBJECTS.HEALTH_SYSTEM)
    can(ACTIONS.EDIT, SUBJECTS.HOSPITALS_IN_HS_DETAILS)
    can(ACTIONS.VIEW, SUBJECTS.BANK_ENROLLED_IN_HOSPITALS_TABLE)
    can(ACTIONS.VIEW, SUBJECTS.DEPARTMENTS_IN_HS_DETAILS)
    can(ACTIONS.VIEW, SUBJECTS.HOSPITALS_IN_HS_DETAILS)
    can(ACTIONS.VIEW, SUBJECTS.USERS_IN_HOSPITAL_DETAILS)
    can(ACTIONS.ARCHIVE, SUBJECTS.HOSPITALS_IN_HS_DETAILS)
    can(ACTIONS.VIEW, SUBJECTS.USERS_IN_HS_DETAILS)
    can(ACTIONS.EDIT, SUBJECTS.USERS_IN_HS_DETAILS)
    can(ACTIONS.CRUD, SUBJECTS.HOSPITAL)
    can(ACTIONS.VIEW, SUBJECTS.FORM_SAVINGS_GOAL)
  }
  if (role === ROLES.COMMUNITY_RCA) {
    can(ACTIONS.VIEW, SUBJECTS.HEALTH_SYSTEM_USERS)
    can(ACTIONS.VIEW, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.HOSPITALS_IN_HS_DETAILS)
  }
  if (role === ROLES.CONTRACT_STEWARD) {
    can(ACTIONS.VIEW, SUBJECTS.COMPLIANCE)
    can(ACTIONS.VIEW, SUBJECTS.CONTRACT_CATEGORY)
    can(ACTIONS.EDIT, SUBJECTS.CONTRACT_CATEGORY)
    can(ACTIONS.VIEW, SUBJECTS.FORM_COMMUNITY_INPUT, isInsideCommunityCondition)
    can(ACTIONS.VIEW, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.FORM_CONTARCT_CATEGORIES_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.FORM_SAVINGS_GOAL)
  }
  if (role === ROLES.HOSPITAL_USER) {
    can(ACTIONS.VIEW, SUBJECTS.ADDITIONAL_INFO_PROFILE)
  }
  if (role === ROLES.HOSPITAL_USER) {
    can(ACTIONS.VIEW, SUBJECTS.FORM_HOSPITAL_LIST)
    can(ACTIONS.VIEW, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.VOTING_PANEL_MEMBERSHIP)
  }
  if (role === ROLES.FINANCE) {
    can(ACTIONS.VIEW, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
  }
  if (role === ROLES.CLINICAL_COORDINATOR) {
    can(ACTIONS.VIEW, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
  }

  if (role === ROLES.HOSPITAL_ADMIN) {
    can(ACTIONS.VIEW, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.FORM_HOSPITAL_INPUT)
  }
  if (role === ROLES.ANALYST || role === ROLES.LEGAL) {
    can(ACTIONS.VIEW, SUBJECTS.FORM_HEALTH_SYSTEM_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.FORM_CONTARCT_CATEGORIES_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.HOSPITALS_IN_HS_DETAILS)
  }
  if (role === ROLES.ANALYST) {
    can(ACTIONS.VIEW, SUBJECTS.COMPLIANCE)
  }

  if (
    (user.role === ROLES.VICE_PRESIDENT ||
      user.role === ROLES.COMMUNITY_PRESIDENT ||
      user.role === ROLES.CONTRACT_STEWARD) &&
    role === ROLES.HOSPITAL_USER
  ) {
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
    can(ACTIONS.UPDATE, SUBJECTS.VOTING_PANEL_MEMBERSHIP)
  }

  if (
    (user.role === ROLES.VICE_PRESIDENT ||
      user.role === ROLES.COMMUNITY_PRESIDENT ||
      user.role === ROLES.CONTRACT_STEWARD) &&
    (role === ROLES.ANALYST || role === ROLES.LEGAL)
  ) {
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES)
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
  }

  if (user.role === ROLES.CONTRACT_STEWARD && role === ROLES.CONTRACT_STEWARD) {
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES_COMMUNITY_LEVEL)
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
    can(
      ACTIONS.VIEW,
      SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES_EXTENDED_VIEW_MODE
    )
  }

  if (
    user.role === ROLES.COMMUNITY_PRESIDENT &&
    (role === ROLES.CONTRACT_STEWARD ||
      role === ROLES.VICE_PRESIDENT ||
      role === ROLES.CLINICAL_COORDINATOR)
  ) {
    // Should be disabled for coordinator edit
    if (role !== ROLES.CLINICAL_COORDINATOR) {
      can(ACTIONS.UPDATE, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
    }
    // Assign button should be disabled for sourcing leader edit
    if (role !== ROLES.VICE_PRESIDENT) {
      can(ACTIONS.CREATE, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
    }
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES_COMMUNITY_LEVEL)
    can(ACTIONS.CRUD, SUBJECTS.USER_CONTRACT_CATEGORIES_COMMUNITY_LEVEL)
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES)
  }

  if (
    user.role === ROLES.VICE_PRESIDENT &&
    (role === ROLES.CONTRACT_STEWARD ||
      role === ROLES.CLINICAL_COORDINATOR ||
      (profileId === user.uuid && role === ROLES.VICE_PRESIDENT))
  ) {
    // Should be disabled for coordinator edit
    if (role !== ROLES.CLINICAL_COORDINATOR) {
      can(ACTIONS.UPDATE, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
    }
    can(ACTIONS.CREATE, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
    can(ACTIONS.VIEW, SUBJECTS.FORM_CONTARCT_CATEGORIES_INPUT)
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES)
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES_COMMUNITY_LEVEL)
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
  }

  if (
    user.role === ROLES.VICE_PRESIDENT &&
    profileId !== user.uuid &&
    role === ROLES.VICE_PRESIDENT
  ) {
    can(ACTIONS.VIEW, SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES)
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES_COMMUNITY_LEVEL)
    can(
      ACTIONS.VIEW,
      SUBJECTS.MY_COMMUNITY_USER_CONTRACT_CATEGORIES_EXTENDED_VIEW_MODE
    )
  }

  if (
    (user.role === ROLES.COMMUNITY_PRESIDENT ||
      user.role === ROLES.VICE_PRESIDENT) &&
    (role === ROLES.CONTRACT_STEWARD || role === ROLES.VICE_PRESIDENT)
  ) {
    can(ACTIONS.VIEW, SUBJECTS.USER_CONTRACT_CATEGORIES_ACTIONS)
  }
}
